import styled from 'styled-components'
import Button from '../../atoms/ButtonAsync/ButtonAsync'
import Breakpoints from '../../theme/breakpoints'
import colors from '../../theme/colors'
import fonts from '../../theme/fonts'
import { MOBILE_HEADER_HEIGHT } from '../MobileHeader/MobileHeader.styles'

export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 8px;
  margin-bottom: 24px;
  outline: none;
  display: flex;
  flex-direction: row;
  justify-content: center;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Ul = styled.ul`
  height: 100%;
  padding: 0 32px 16px 32px;

  @media (max-width: ${Breakpoints.tablet}) {
    margin-top: ${MOBILE_HEADER_HEIGHT};
    padding-top: 16px;
    overflow-y: auto;
  }

  background-color: ${colors.Primary.Black};
  user-select: none;
  list-style: none;
  margin: 0;

  li {
    padding: 0;

    a,
    a:visited {
      display: flex;
      align-items: center;
      height: 40px;

      color: ${colors.Primary.GreyTextLight} !important;

      font-family: ${fonts.fontFamilies.Inter};
      font-style: normal;
      font-weight: ${fonts.fontWeights.medium};
      font-size: ${fonts.fontSizes.p16};
      line-height: 16px;
      text-decoration: none;
      underline: none;

      padding: 0 0 0 0;
      margin: 12px 0 0 0;

      border-radius: 4px;

      &:hover {
        background: ${colors.Primary.GreyDark};
        text-decoration: none;
        color: ${colors.Primary.White} !important;
        cursor: pointer;

        path {
          fill: ${colors.Primary.White};
        }
      }

      &[aria-selected='true'] {
        background: ${colors.Primary.GreyDark};
        color: ${colors.Primary.White} !important;
      }

      svg {
        margin: 0 15px;
      }
    }
  }

  hr {
    border-top: 1px solid ${colors.Primary.GreyTextLight};
    border-bottom: none;
    border-left: none;
    border-right: none;
    margin: 20px 0;
  }
`

export const NumberBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 6px;
  width: 20px;
  height: 20px;
  background: ${colors.Primary.yellow500};
  border-radius: 4px;
  color: ${colors.Primary.GreyText};
`
export const AttentionBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 6px;
  width: 20px;
  height: 20px;
  background: ${colors.Secondary.red200};
  border-radius: 4px;
  color: white;
`
